module.exports = __webpack_public_path__ + "img/agents-black.eb4549d8.svg";